import { render, staticRenderFns } from "./stumall.vue?vue&type=template&id=4cfe3dd9&scoped=true"
import script from "./stumall.vue?vue&type=script&lang=js"
export * from "./stumall.vue?vue&type=script&lang=js"
import style0 from "./stumall.vue?vue&type=style&index=0&id=4cfe3dd9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfe3dd9",
  null
  
)

export default component.exports